<template>
  <div class="fs-14 lh-24 fw-400">The trip you’re looking for doesn’t seem to exist.</div>
  <div class="fs-14 lh-24 fw-400 mt-10">Please send us an email at <a href="mailto:travel@designerjourneys.com"><span class="black underline">travel@designerjourneys.com</span></a> for further support.</div>
</template>
